import { sharedExtensionCards } from "backend/src/common/gameData/extensions.shared";
import { ExtensionType } from "backend/src/common/types/ExtensionCard";
import { Card } from "components/Card/Card";
import React, { useLayoutEffect } from "react";

import styles from "./styles.module.scss";
import { extensionImages } from "./images";
import { ScrollYoyo } from "components/ScrollYoyo/ScrollYoyo";
import { useHover } from "hooks/useHover";
import { numberWithSign } from "utils/numberWithSign";
import { useI18n } from "i18n/I18nProvider";
import { getExtensionTexts } from "backend/src/common/i18n";

type TDemoCardProps = {
  type: ExtensionType;
  innerRef?: (el: HTMLDivElement) => void;
};

export const DemoCard: React.FC<TDemoCardProps> = ({ type, innerRef }) => {
  const { locale } = useI18n();
  const [isHovered, onMouseOver, onMouseOut] = useHover();
  const extensionData = sharedExtensionCards[type];
  const extensionTexts = getExtensionTexts(locale, type);
  const additionalFood =
    extensionData.additionalFoodLabel ||
    (extensionData.additionalFood
      ? numberWithSign(extensionData.additionalFood)
      : "");

  const cardRef = React.useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (cardRef.current) {
      innerRef?.(cardRef.current);
    }
  }, [innerRef]);

  return (
    <Card
      cardRef={cardRef}
      title={extensionTexts.name}
      afterTitle={additionalFood}
      red={type === ExtensionType.predator}
      pink={extensionData.canBeAddedToEnemyAnimal}
      yellow={type === ExtensionType.fat}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
    >
      <div className={styles.cardContent}>
        <ScrollYoyo active={isHovered} className={styles.description}>
          {extensionTexts.description}
        </ScrollYoyo>
        {extensionImages[type] && (
          <div className={styles.image}>
            <img src={extensionImages[type]?.empty} />
          </div>
        )}
      </div>
    </Card>
  );
};
